import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {fetchWrapper } from './../_helpers';

// create slice

const name = 'client';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const clientActions = { ...slice.actions, ...extraActions };
export const clientReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        client:{},
        clientList: [],
        error: null,
        clientResponse: [],
        deleteClientResponse:[],
         isLoading:false
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/Client`;
    return {
       getClientAll: getClientAll(),
       getClientById:getClientById(),
        saveClient: saveClient(),
        deleteClient:deleteClient(),
    };

    function getClientAll() {
        return createAsyncThunk(
            `${name}/getClientAll`,
            async (details) => await fetchWrapper.post(`${baseUrl}/GetClientDetails`, details)
        );
    }

     function getClientById() {
        return createAsyncThunk(
            `${name}/getClientById`,
            async (ClientID) => await fetchWrapper.get(`${baseUrl}/GetClientDetailsByID?ClientID=${ClientID}`)
        );
    }


  function saveClient() {
        return createAsyncThunk(
            `${name}/saveClient`,
           async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateClient`, addFormData)
        );
    }

     function deleteClient()
    {
        return createAsyncThunk(
            `${name}/deleteClient`,
             async (ClientDetail) => await fetchWrapper.post(`${baseUrl}/DeleteClient?ClientID=${ClientDetail.ClientID}&DeletedBy=${ClientDetail.DeletedBy}`)
          
        );
    }
}

function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getClientAll.pending, (state) => {
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getClientAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.clientList = action.payload;
            state.clientResponse = [];
            state.deleteClientResponse = [];
        })
        .addCase(extraActions.getClientAll.rejected, (state, action) => {
            state.isLoading = false;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getClientById.pending, (state) => {
            state.client = { loading: true };
        })
        .addCase(extraActions.getClientById.fulfilled, (state, action) => {
            state.client = action.payload;
            state.clientResponse = [];
            state.deleteClientResponse = [];
        })
        .addCase(extraActions.getClientById.rejected, (state, action) => {
            state.client = { error: action.error };
        })
        .addCase(extraActions.saveClient.pending, (state) => {
            state.clientResponse = { loading: true };
        })
        .addCase(extraActions.saveClient.fulfilled, (state, action) => {
            state.clientResponse = action.payload;
            state.deleteClientResponse = [];
        })
        .addCase(extraActions.saveClient.rejected, (state, action) => {
            state.clientResponse = { error: action.error };
        })
        .addCase(extraActions.deleteClient.pending, (state) => {
            state.deleteClientResponse = { loading: true };
        })
        .addCase(extraActions.deleteClient.fulfilled, (state, action) => {
            state.deleteClientResponse = action.payload;
            state.clientResponse = [];
        })
        .addCase(extraActions.deleteClient.rejected, (state, action) => {
            state.deleteClientResponse = { error: action.error };
        });
}































